import React, { useState, useEffect } from "react";
import api from "../services/api";

const statusColors = { pending: "#E65100", paid: "#1A5C2A", overdue: "#D32F2F" };
const statusLabels = { pending: "En attente", paid: "Paye", overdue: "En retard" };
const typeLabels = { property: "Taxe Fonciere", sweeping: "Taxe de Balayage", business: "Taxe Commerciale", other: "Autre" };

export default function PaymentsPage() {
  const [taxes, setTaxes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ tax_type: "property", amount: "", due_date: "", year: new Date().getFullYear(), citizen_email: "" });
  const [filter, setFilter] = useState("all");

  useEffect(() => { loadTaxes(); }, []);

  const loadTaxes = () => {
    setLoading(true);
    api.get("/payments/taxes/").then(r => {
      setTaxes(Array.isArray(r.data) ? r.data : r.data.results || []);
      setLoading(false);
    }).catch(() => setLoading(false));
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    try {
      await api.post("/payments/taxes/create/", form);
      setShowForm(false);
      setForm({ tax_type: "property", amount: "", due_date: "", year: new Date().getFullYear(), citizen_email: "" });
      loadTaxes();
    } catch(err) { alert("Erreur: " + (err.response?.data?.error || "Inconnue")); }
  };

  const filtered = filter === "all" ? taxes : taxes.filter(t => t.status === filter);
  const total = taxes.reduce((sum, t) => sum + parseFloat(t.amount || 0), 0);
  const pending = taxes.filter(t => t.status === "pending").reduce((sum, t) => sum + parseFloat(t.amount || 0), 0);

  const s = { width: "100%", padding: "10px 14px", border: "1px solid #E8E8F0", borderRadius: 10, fontSize: 14, fontFamily: "Poppins", outline: "none", boxSizing: "border-box" };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
        <div>
          <h1 style={{ color: "#1A1A2E", fontSize: 24, fontWeight: 800, margin: 0 }}>Paiements & Taxes</h1>
          <p style={{ color: "#8A8A9A", fontSize: 14, margin: "4px 0 0" }}>{taxes.length} taxe(s) au total</p>
        </div>
        <button onClick={() => setShowForm(true)} style={{ background: "linear-gradient(135deg, #0F3D1A, #1A5C2A)", color: "white", border: "none", padding: "12px 24px", borderRadius: 12, cursor: "pointer", fontSize: 14, fontWeight: 700, fontFamily: "Poppins" }}>
          + Creer une taxe
        </button>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 16, marginBottom: 24 }}>
        {[
          { label: "Total des taxes", value: total.toLocaleString() + " FCFA", color: "#1A5C2A" },
          { label: "En attente", value: pending.toLocaleString() + " FCFA", color: "#E65100" },
          { label: "Taxes creees", value: taxes.length, color: "#1565C0" },
        ].map((s, i) => (
          <div key={i} style={{ background: "white", borderRadius: 16, padding: 20, boxShadow: "0 2px 8px rgba(0,0,0,0.06)", borderLeft: `4px solid ${s.color}` }}>
            <p style={{ margin: "0 0 8px", color: "#8A8A9A", fontSize: 13 }}>{s.label}</p>
            <h2 style={{ margin: 0, color: "#1A1A2E", fontSize: 22, fontWeight: 800 }}>{s.value}</h2>
          </div>
        ))}
      </div>

      {showForm && (
        <div style={{ background: "white", borderRadius: 20, padding: 28, marginBottom: 24, boxShadow: "0 4px 12px rgba(0,0,0,0.1)", border: "2px solid #1A5C2A" }}>
          <h3 style={{ margin: "0 0 20px" }}>Creer une nouvelle taxe</h3>
          <form onSubmit={handleCreate}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 16 }}>
              <div><label style={{ fontSize: 13, fontWeight: 600, display: "block", marginBottom: 4 }}>Email citoyen *</label><input value={form.citizen_email} onChange={e => setForm({...form, citizen_email: e.target.value})} required placeholder="citoyen@email.com" style={s} /></div>
              <div><label style={{ fontSize: 13, fontWeight: 600, display: "block", marginBottom: 4 }}>Type de taxe *</label>
                <select value={form.tax_type} onChange={e => setForm({...form, tax_type: e.target.value})} style={s}>
                  {Object.entries(typeLabels).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                </select>
              </div>
              <div><label style={{ fontSize: 13, fontWeight: 600, display: "block", marginBottom: 4 }}>Montant (FCFA) *</label><input type="number" value={form.amount} onChange={e => setForm({...form, amount: e.target.value})} required placeholder="50000" style={s} /></div>
              <div><label style={{ fontSize: 13, fontWeight: 600, display: "block", marginBottom: 4 }}>Date echeance *</label><input type="date" value={form.due_date} onChange={e => setForm({...form, due_date: e.target.value})} required style={s} /></div>
              <div><label style={{ fontSize: 13, fontWeight: 600, display: "block", marginBottom: 4 }}>Annee</label><input type="number" value={form.year} onChange={e => setForm({...form, year: e.target.value})} style={s} /></div>
            </div>
            <div style={{ display: "flex", gap: 12 }}>
              <button type="submit" style={{ background: "#1A5C2A", color: "white", border: "none", padding: "10px 24px", borderRadius: 10, cursor: "pointer", fontFamily: "Poppins", fontWeight: 600 }}>Creer</button>
              <button type="button" onClick={() => setShowForm(false)} style={{ background: "#F5F6FA", color: "#8A8A9A", border: "none", padding: "10px 24px", borderRadius: 10, cursor: "pointer", fontFamily: "Poppins" }}>Annuler</button>
            </div>
          </form>
        </div>
      )}

      <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
        {["all", "pending", "paid", "overdue"].map(f => (
          <button key={f} onClick={() => setFilter(f)}
            style={{ padding: "8px 16px", borderRadius: 20, border: "none", cursor: "pointer", fontFamily: "Poppins", fontSize: 12, fontWeight: 600, background: filter === f ? "#1A5C2A" : "white", color: filter === f ? "white" : "#8A8A9A", boxShadow: "0 2px 6px rgba(0,0,0,0.05)" }}>
            {f === "all" ? "Toutes" : statusLabels[f]}
          </button>
        ))}
      </div>

      {loading ? <p style={{ textAlign: "center", color: "#8A8A9A" }}>Chargement...</p> : (
        <div style={{ display: "grid", gap: 10 }}>
          {filtered.map(tax => (
            <div key={tax.id} style={{ background: "white", borderRadius: 14, padding: 16, boxShadow: "0 2px 8px rgba(0,0,0,0.05)", display: "flex", alignItems: "center", gap: 14, borderLeft: `4px solid ${statusColors[tax.status] || "#8A8A9A"}` }}>
              <div style={{ flex: 1 }}>
                <div style={{ display: "flex", gap: 8, marginBottom: 4 }}>
                  <span style={{ background: (statusColors[tax.status] || "#8A8A9A") + "20", color: statusColors[tax.status] || "#8A8A9A", padding: "2px 8px", borderRadius: 6, fontSize: 11, fontWeight: 700 }}>{statusLabels[tax.status] || tax.status}</span>
                  <span style={{ background: "#F5F6FA", color: "#8A8A9A", padding: "2px 8px", borderRadius: 6, fontSize: 11 }}>{typeLabels[tax.tax_type] || tax.tax_type}</span>
                </div>
                <p style={{ margin: 0, fontWeight: 700, color: "#1A1A2E", fontSize: 15 }}>{parseFloat(tax.amount).toLocaleString()} FCFA</p>
                <p style={{ margin: "2px 0 0", color: "#8A8A9A", fontSize: 12 }}>Ref: {tax.reference} • Echeance: {tax.due_date} • {tax.citizen?.email || ""}</p>
              </div>
            </div>
          ))}
          {filtered.length === 0 && <p style={{ textAlign: "center", color: "#8A8A9A", padding: 40 }}>Aucune taxe</p>}
        </div>
      )}
    </div>
  );
}
